function applyRollingEffect() {
  const rolledElements = document.querySelectorAll(".simple-tags");

  rolledElements.forEach((rolledElement) => {
    if (rolledElement) {
      rolledElement.style.height = "";
      rolledElement.style.overflow = "";
      const existingButton = rolledElement.nextElementSibling;
      if (existingButton && existingButton.classList.contains("rolled")) {
        existingButton.remove();
      }

      if (rolledElement.offsetHeight > 174) {
        rolledElement.style.height = "174px";
        rolledElement.style.overflow = "hidden";

        const button = document.createElement("a");
        button.classList.add(
          "btn-solid",
          "btn-black",
          "text-black",
          "fs-14",
          "fw-500",
          "d-flex",
          "rolled"
        );
        button.textContent = "Rozwiń wszystkie";

        rolledElement.insertAdjacentElement("afterend", button);

        button.addEventListener("click", () => {
          if (rolledElement.classList.contains("expand")) {
            rolledElement.classList.remove("expand");
            rolledElement.style.height = "174px";
            rolledElement.style.overflow = "hidden";
            button.classList.remove("expand");
            button.classList.add("rolled");
            button.textContent = "Rozwiń";
          } else {
            rolledElement.classList.add("expand");
            rolledElement.style.height = "100%";
            rolledElement.style.overflow = "visible";
            button.classList.remove("rolled");
            button.classList.add("expand");
            button.textContent = "Zwiń";
          }
        });
      }
    }
  });
}

window.addEventListener("load", applyRollingEffect);

window.addEventListener("resize", () => {
  clearTimeout(window.resizedFinished);
  window.resizedFinished = setTimeout(applyRollingEffect, 300);
});
